<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de Efectividad por Productos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_fecha"
                  id="tipo_fecha"
                  v-model="form.tipo_fecha"
                >
                  <option value="H">Hoy</option>
                  <option value="A">Ayer</option>
                  <option value="P">Personalizado</option>
                </select>
                <label for="tipo_fecha">Tipo de fecha</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  v-model="form.desde"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="hasta"
                  v-model="form.hasta"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select name="bodega" id="bodega" v-model="form.bodega_id">
                  <option value="">Todas</option>
                  <option
                    v-for="bodega in bodegas"
                    :key="bodega.id"
                    :value="bodega.id"
                  >
                    {{ bodega.descripcion }}
                  </option>
                </select>
                <label for="bodega">Bodega</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-8">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputProductos"
                  id="productos"
                  multiple
                  @search="searchItems"
                  v-model="selectedProductos"
                  :options="productos"
                  label="nombre"
                  placeholder="Seleccione..."
                ></v-select>
                <label for="productos">Productos</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="form-field select">
              <div class="select-field">
                <select
                  name="tipo_venta"
                  id="tipo_venta"
                  v-model="form.tipo_venta"
                >
                  <option value="">Todas</option>
                  <option value="MAY">Mayores a</option>
                  <option value="MEN">Menores a</option>
                </select>
                <label for="tipo_venta">Ventas</label>
              </div>
            </div>
          </div>
          <div v-show="form.tipo_venta !== ''" class="col-xs-12 col-md-1">
            <div class="form-field">
              <input-field
                placeholder="Valor..."
                id="valor_venta"
                v-model="form.valor_venta"
              ></input-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__content">
        <div style="max-height: 300px" class="table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th v-for="dia in dias" :key="dia">
                  {{ dia }}
                </th>
                <th>Total</th>
                <th>Devueltas</th>
                <th>Cobradas</th>
                <th>No Cobradas</th>
                <th>Valor</th>
                <th>% Cobradas</th>
                <th>% No Cobradas</th>
                <th>% Devueltas</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="producto in efectividad" :key="producto.codigo">
                <th scope="row">
                  {{ producto.descripcion }}
                </th>
                <td v-for="dia in dias" :key="dia">
                  {{ producto[dia] != null ? parseInt(producto[dia]) : 0 }}
                </td>
                <td>
                  <strong>{{ producto.total }}</strong>
                </td>
                <td>
                    {{ producto.devueltas }}
                </td>
                <td>
                    {{ producto.cobradas }}
                </td>
                <td>
                    {{ producto.no_cobradas }}
                </td>
                <td>
                    {{ producto.valor }}
                </td>
                <td>
                    {{ producto.porc_cobradas }}
                </td>
                <td>
                    {{ producto.porc_no_cobradas }}
                </td>
                <td>
                    {{ producto.porc_no_devueltas }}
                </td>
              </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th scope="row">
                        Totales
                    </th>
                    <td v-for="dia in dias" :key="dia">
                        {{ calcularTotal(dia) }}
                    </td>
                    <td>
                        <strong>{{ total }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('devueltas') }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('cobradas') }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('no_cobradas') }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('valor') }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('tarjetas') > 0?(round((calcularTotal('cobradas') / calcularTotal('tarjetas')) * 100, 2)):0 }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('tarjetas') > 0?(round((calcularTotal('no_cobradas') / calcularTotal('tarjetas')) * 100, 2)):0 }}</strong>
                    </td>
                    <td>
                        <strong>{{ calcularTotal('tarjetas') > 0?(round((calcularTotal('devueltas') / calcularTotal('tarjetas')) * 100, 2)):0 }}</strong>
                    </td>
                </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        total: function () {
            let total = 0;
            for (let i = 0; i < this.efectividad.length; i++) {
                total += parseInt(this.efectividad[i].total);
            }
            return total;
        },
    },
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      form: {
        productos_id: [],
        tipo_venta: "",
        valor_venta: 0,
        tipo_fecha: "P",
        desde: "",
        hasta: "",
        bodega_id: "",
        tipo_reporte: 'N'
      },
      selectedProductos: [],
      productos: [],
      efectividad: [],
      dias: [],
      round: round
    };
  },
  mounted: function () {
    this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
    let desde = new Date();
    desde.setDate(desde.getDate() - 7);
    this.form.desde = moment(desde).format("YYYY-MM-DD");
  },
  methods: {
    searchItems: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.productos = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/items?search=" + search, true);
      xmlhttp.send();
    },
    calcularTotal: function (dia) {
        let total = 0;
        for (let i = 0; i < this.efectividad.length; i++) {
            if (this.efectividad[i][dia] != null) {
                total += parseInt(this.efectividad[i][dia]);
            }
        }
        return total;
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportar: function () {
      this.form.tipo_reporte = "E";
      let urlApi = `${url}/reporte-efectividad-productos${this.serialize(this.form)}`;
      window.open(urlApi, "_blank");
    },
    consultar: function () {
        this.form.tipo_reporte = "N";
      axios
        .get(url + "/reporte-efectividad-productos", {
          params: this.form,
        })
        .then(({ data }) => {
          this.efectividad = data.efectividad;
          this.dias = data.dias;
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputProductos: function () {
      this.form.productos_id.splice(0, this.form.productos_id.length);
      for (let i = 0; i < this.selectedProductos.length; i++) {
        this.form.productos_id.push(this.selectedProductos[i].id);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteEfectividadProductos.vue